export default __webpack_public_path__ + "static/caffeineLogo-0285c74ab8495caf8065a50847df7649.png";